<template>
  <div class="articles-container">
    <div v-if="loading" class="spinner-container bg-light">
      <div class="spinner"></div>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      {{ $t("articles.error_loading") }}
    </div>

    <div v-else>
      <div v-if="articles.length > 0" class="search-result d-flex justify-content-between mb-3">
        <p class="mb-0">{{ $t("articles.search_results", { count: articles.length }) }}</p>
      </div>
        <div class="articles-grid">
          <div v-for="(article, rowIndex) in articles" :key="rowIndex" >
            <ArticleCard :article="article" />
          </div>
        </div>

      <div v-if="articles.length === 0" class="no-articles text-center py-5">
        <p class="text-muted">{{ $t("articles.no_articles") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import ArticleCard from "./ArticleCard.vue";
  import { useArticlesStore } from "@/stores/articlesStore";
  import { useAuthStore } from "@/stores/authStore";

  export default {
    name: "ArticleList",
    components: {
      ArticleCard,
    },
    data() {
      return {
        articlesStore: null,
        authStore: null,
      };
    },
    computed: {
    
      articles() {
       return this.articlesStore.filteredArticles.filter(
        (article) => article?.pageType?.name === "Actualités"
      );
      },
      loading() {
        return this.articlesStore.isLoading;
      },
      error() {
        return this.articlesStore.currentError;
      },
    },
    async created() {
      this.articlesStore = useArticlesStore();
      this.authStore = useAuthStore();

      await this.loadArticles();
    },
    methods: {
      async loadArticles() {
        await this.articlesStore.fetchArticles();
      },
    },
  };
</script>

<style scoped>
  .articles-container {
    width: 100%;
  }

  .articles-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 20px;
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }

  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #ec621a;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .search-result {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }

  .no-articles {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pagination-container {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .pagination .page-link {
    color: #1e347d;
    border-color: #1e347d;
    padding: 8px 16px;
  }

  .pagination .page-link:hover {
    background-color: #ec621a;
    border-color: #ec621a;
    color: white;
  }

  .pagination .page-item.active .page-link {
    background-color: #1e347d;
    border-color: #1e347d;
    color: white;
  }

  .pagination .page-item.disabled .page-link {
    color: #6c757d;
    background-color: #fff;
    border-color: #dee2e6;
  }

  @media (max-width: 768px) {
    .articles-grid {
      gap: 12px;
    }

    .pagination .page-link {
      padding: 6px 12px;
      font-size: 14px;
    }
  }
</style>
